import React from "react";
import PropTypes from "prop-types";

import { FIELD_TYPE } from "../../../../../Task/components/TaskConditionModal/hooks/useConditionController";
import { FormFieldText, StreamsTagsText, ThisWorkflowText } from "./components";

export function ConditionValue({
  type,
  operand,
  formFieldType,
  value,
  datePart,
  streams,
  tags,
}) {
  const getTextValue = () => {
    switch (type) {
      case FIELD_TYPE.STREAM_AND_TAG:
        return <StreamsTagsText streams={streams} tags={tags} />;
      case FIELD_TYPE.THIS_WORKFLOW:
        return <ThisWorkflowText value={value} datePart={datePart} />;
      case FIELD_TYPE.FORM_FIELD:
        return (
          <FormFieldText
            formFieldType={formFieldType}
            value={value}
            datePart={datePart}
          />
        );
      default:
        return null;
    }
  };

  return (
    <React.Fragment>
      <span data-test="condition-operand" style={{ marginRight: ".5em" }}>
        {operand}
      </span>
      <div data-test="condition-value">{getTextValue()} </div>
    </React.Fragment>
  );
}

ConditionValue.propTypes = {
  type: PropTypes.oneOf([
    FIELD_TYPE.STREAM_AND_TAG,
    FIELD_TYPE.FORM_FIELD,
    FIELD_TYPE.THIS_WORKFLOW,
  ]).isRequired,
  operand: PropTypes.string.isRequired,
  formFieldType: PropTypes.shape({ id: PropTypes.string }),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  datePart: PropTypes.string,
  streams: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      color: PropTypes.string,
    })
  ),
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ),
};

ConditionValue.defaultProps = {
  formFieldType: null,
  value: null,
  datePart: null,
  streams: [],
  tags: [],
};

export default ConditionValue;
